export default __webpack_public_path__ + "static/media/device-bolt.c9a4e81e.png";